import React, {useState} from 'react';
import ArrRichTextEditor from '../../../components/common/arr-rich-text-editor/ArrRichTextEditor';

function RichTextEditorDemo() {
  const [content, setContent] = useState('');
  return (
    <div style={{padding: '50px'}}>
      <ArrRichTextEditor value={content} onChange={setContent} />

      <div style={{marginTop: '50px'}}>{content}</div>
    </div>
  );
}

export default RichTextEditorDemo;
